import React from 'react'
import { ResponsiveBackgroundImage } from '@/atoms/ResponsiveBackgroundImage'
import { ParagraphXL } from '@/atoms/Typography'
import { useTranslate } from '@/utils/translate/translate-client'

const responsiveAR = { xs: '16:9', sm: '16:9' }

interface LivestreamOverProps {
  bannerCloudinaryPath: string
}

export const LivestreamOver: React.FC<LivestreamOverProps> = ({ bannerCloudinaryPath }) => {
  const { t } = useTranslate('livestream')

  return (
    <div className="relative h-[60vh] bg-black">
      <ResponsiveBackgroundImage backgroundSize="bg-contain" src={bannerCloudinaryPath} responsiveAR={responsiveAR} />
      <div className="absolute left-1/2 top-1/2 h-fit w-fit -translate-x-1/2 -translate-y-1/2 bg-black/80 p-4 text-center">
        <ParagraphXL>{t('theLivestreamHasEnded', 'The livestream has ended.')}</ParagraphXL>
        <ParagraphXL>{t('thankYouForWatching', 'Thank you for watching!')}</ParagraphXL>
      </div>
    </div>
  )
}
